import { authenticatedFetch } from 'api/fetch';
import {
  CompletedEvaluation,
  EvaluatorLink,
  type PaginatedResponse,
} from 'api/httpEntities';
import { buildUrlWithSearchParams, cleanObject } from 'api/utils';
import { PractitionerData } from 'components/EventForms/types';
import { PaginatedOrgEvaluatorLinkParams } from 'pages/EvaluatorLinks/useSortedEvaluatorLinks';
import { DefaultPageParam } from 'api/search';
import { GetCompletedEvaluatorsRequest } from 'api';

export const deleteEvaluatorLink = async (id: string): Promise<void> => {
  const url = `/api/v1/evaluator-links/${id}`;
  const { json } = await authenticatedFetch(url, { method: 'DELETE' });

  await json();
};

export const getEvaluatorLink = async (id: string) => {
  const { json } = await authenticatedFetch<EvaluatorLink>(
    `/api/v1/evaluator-links/${id}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  return json();
};

export const getCompletedEvaluators = async (
  queryParams?: DefaultPageParam & GetCompletedEvaluatorsRequest,
): Promise<PaginatedResponse<CompletedEvaluation>> => {
  const { id, searchTerm, purchaseStatus, searchMode, query } =
    queryParams || {};
  const queries = new URLSearchParams(
    cleanObject({
      responseSize: '300',
      purchaseStatus,
      ...(searchTerm ? { searchTerm, searchMode } : {}),
      ...(query ? { query } : {}),
    }),
  );
  const url = `/api/v1/evaluator-links/${id}/evaluations?${queries.toString()}`;
  const { json } = await authenticatedFetch<
    PaginatedResponse<CompletedEvaluation>
  >(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return json();
};

export const updateNotificationSettings = async ({
  evaluatorId,
  practitionerIds,
}: {
  evaluatorId: string;
  practitionerIds: string[];
}) => {
  const url = `/api/v1/evaluator-links/${evaluatorId}/notifications`;
  const { json } = await authenticatedFetch(url, {
    method: 'POST',
    body: JSON.stringify({ practitionerIds }),
    headers: { 'Content-Type': 'application/json' },
  });

  return await json();
};

export const updateReferralCodeMandatory = async ({
  evaluatorId,
  isReferralCodeMandatory,
}: {
  evaluatorId: string;
  isReferralCodeMandatory: boolean;
}) => {
  const url = `/api/v1/evaluator-links/${evaluatorId}/referralCode`;
  const { json } = await authenticatedFetch(url, {
    method: 'PUT',
    body: JSON.stringify({ mandatory: isReferralCodeMandatory }),
    headers: { 'Content-Type': 'application/json' },
  });

  return await json();
};

export const getNotifiablePractitioners = async (evaLinkId: string) => {
  const url = `/api/v1/evaluator-links/${evaLinkId}/practitioners`;
  const { json } = await authenticatedFetch<PractitionerData>(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  return await json();
};
export const getEvaluatorLinks = async (
  queryParams?: PaginatedOrgEvaluatorLinkParams,
): Promise<PaginatedResponse<EvaluatorLink>> => {
  const url = buildUrlWithSearchParams(`/api/v1/evaluator-links`, queryParams);
  const { json } = await authenticatedFetch<PaginatedResponse<EvaluatorLink>>(
    url,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  return json();
};
